define(function(){
  window.DEBUG = location.hostname === 'localhost' ? true : false;
  return window;
});